import { formatDistance } from "date-fns";
import { useMemo } from "react";

const options: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
};
const locale = undefined; // Use default locale for current user agent
const formatter = new Intl.DateTimeFormat(locale, options);

function formatDate(dateString: string) {
  return (
    formatDistance(new Date(), new Date(dateString), { includeSeconds: true }) +
    " ago"
  );
}

function removeAboutPrefix(s: string) {
  return s.startsWith("about ") ? s.substring("about ".length) : s;
}

export function ActivityDate({ date }: { date: string | undefined }) {
  const { distanceString, tooltip, className } = useMemo(
    () =>
      date
        ? {
            distanceString: removeAboutPrefix(formatDate(date)),
            tooltip: formatter.format(new Date(date)),
            className: undefined,
          }
        : {
            distanceString: "-",
            tooltip: undefined,
            className: "text-muted",
          },
    [date]
  );
  return (
    <span title={tooltip} className={className}>
      {distanceString}
    </span>
  );
}
